module.exports = __webpack_public_path__ + "static/media/contact.1f87e9ba.jpeg";